const state = {
    logs: { data: [], current_page: 1, total: 0, per_page: 20, last_page: 1 }
}
export default state;
